import { Component } from 'react';
import * as Sentry from '@sentry/react';
import Alert from 'components/CncUI/Alert';
import Typography from 'components/CncUI/Typography';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error) {
    // You can also log the error to an error reporting service
    if (this.props.errorHandler) this.props.errorHandler();
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.props.fallback) return this.props.fallback;
      if (this.props.alert)
        return (
          <Alert error id="ErrorBoundary-ErrorAlert">
            {this.props.message || 'Something went wrong.'}
          </Alert>
        );
      return (
        <Typography variant="caption">
          {this.props.message || 'Something went wrong.'}
        </Typography>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
